import { TextField } from '@shared/ui/kit';
import { Tiptap } from '@shared/ui/tiptap';
import { StylesText } from '@entities/leadCollector';
import { InfoFilledIcon } from '@shared/assets/icons';
import clsx from 'clsx';
import styles from './invitation-text-field.module.scss';

interface InvitationTextFieldProps {
  isSmsInvitationMode: boolean;
  isBothInvitationMode: boolean;
  invitationSmsText: string;
  invitationTextParts: number;
  invitationText: string;
  invitationTextBodyError?: string | null;
  onInvitationTextChange: (value: string) => void;
}

export const InvitationTextField = ({
  isSmsInvitationMode,
  isBothInvitationMode,
  invitationSmsText,
  invitationTextParts,
  invitationText,
  invitationTextBodyError,
  onInvitationTextChange,
}: InvitationTextFieldProps) => {
  if (isSmsInvitationMode) {
    return (
      <div className={styles.textFieldWrapper}>
        <div className={styles.textFieldHeader}>
          <p className={styles.textFieldLabel}>Текст приглашения</p>
          <p className={styles.textCounter}>
            {invitationSmsText.length} ({invitationTextParts} смс)
          </p>
        </div>
        <TextField
          labelMsg=""
          changeFunction={(event) => onInvitationTextChange(event.target.value)}
          placeholder="Введите текст"
          value={invitationText}
          status={invitationTextBodyError ? 'error' : 'default'}
          textareaMessage={invitationTextBodyError ?? undefined}
          settings={{
            width: '100%',
            cursor: 'text',
            resize: 'vertical',
            height: 'auto',
            minHeight: '102px',
            overflow: 'auto',
          }}
        />
      </div>
    );
  }

  return (
    <div className={styles.textFieldWrapper}>
      <p className={styles.textFieldLabel}>Текст приглашения</p>
      <div className={clsx(styles.formattedTextEditor, invitationTextBodyError && styles.formattedTextEditorError)}>
        <Tiptap
          className={styles.formattedTextEditorContent}
          placeholder="Введите текст"
          onChange={onInvitationTextChange}
          properties={{ link: true, styles: [StylesText.BOLD, StylesText.ITALIC, StylesText.UNDERLINE] }}
          withToolbar
          hiddenStyles={[StylesText.LEFT, StylesText.CENTER, StylesText.RIGHT, StylesText.JUSTIFY]}
          content={invitationText}
        />
      </div>
      {invitationTextBodyError && <p className={styles.invitationTextValidation}>{invitationTextBodyError}</p>}
      {isBothInvitationMode && (
        <div className={styles.formattingInfoAlert}>
          <span className={styles.formattingInfoAlertIcon}>
            <InfoFilledIcon size="16" />
          </span>
          <span>Форматирование будет применено только к email</span>
        </div>
      )}
    </div>
  );
};
